<div class="dsh-action-item">
    <dsh-bi class="icon" [icon]="iconName"></dsh-bi>
</div>
